import axiosInstance from "../axiosInterceptor";

export async function getCoursesRandomly() {
    const response = await axiosInstance.get(`/admin/course/getCoursesRandomly`);
    const data = response?.data;
    return data;
}